import React from "react";

import { closeSnackbar, enqueueSnackbar, SnackbarKey } from "notistack";

import { SnackbarCloseIcon } from "@/taskpane/components/snackbar-provider";

export const handleError = (error: unknown, consoleMesssage: string, notifiedMessage: string | null, optionalAction?: () => void): null => {
    console.error(consoleMesssage, error);

    // N'afficher le snackbar que si un message est fourni
    if (notifiedMessage) {
        enqueueSnackbar(notifiedMessage, {
            variant: "error",
            persist: true,
            action: (snackbarId: SnackbarKey | undefined) => (
                <SnackbarCloseIcon handleClose={() => closeSnackbar(snackbarId)} />
            )
        });
    }

    if (optionalAction) {
        optionalAction();
    }

    return null
}